import { useQuery } from "@tanstack/react-query";
import api from "@/services/api";
import { queryKeys } from "@/queryKeys";
import type { DataMerchNote } from "@/components/defaultHistory/DefaultHistory";

export function useDatamerchNotesQuery(borrowerId: string | null, enabled = true) {
  const id = borrowerId ?? null;
  return useQuery({
    queryKey: queryKeys.datamerchNotes(id),
    queryFn: async (): Promise<DataMerchNote[]> => {
      const response = await api.get<DataMerchNote[]>(`/borrowers/${id}/datamerch-notes/`);
      return response.data ?? [];
    },
    enabled: !!id && enabled,
  });
}
